<template>
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <line-chart :data="data" :download="true" :library="{steppedLine: 'before'}" />
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    data: Array,
  },
}
</script>

<style>

</style>
